enum ePaymentMode {
  MODE_OFFLINE = "offline",
  MODE_BOOKER = "booker",
  MODE_POS = "pos",
  MODE_POS_TERMINAL = "pos_terminal",
  MODE_PAYMENT_LINK = "payment_link",
  MODE_MANUAL_UPDATE = "manual_update",
}

export default ePaymentMode
